import type {NormalizedAsset} from "@songfinch/types";

export type ReviewType = {
    contentTypeId: "review"
    reviewText: string;
    avatar: {
        name: string;
        meta?: string;
        image?: NormalizedAsset;
    }
}

export type PressReviewType = {
    contentTypeId: "pressReview";
    reviewText: string;
    logo: NormalizedAsset;
}

export type RevealType = {
    contentTypeId: "reveal";
    title: string;
    subtext: string;
    placeholder: NormalizedAsset;
    video: NormalizedAsset;
}

export type ReviewCardTypes = ReviewType | PressReviewType | RevealType;

export const reviewCards: ReviewCardTypes[] = [
    {
        contentTypeId: "reveal",
        title: "Thick and Thin",
        subtext: "by MillyannaMusic",
        placeholder: {
            title: "Thick and Thin Image",
            url: "https://content.songfinch.com/res/songfinch/image/asset/static/thick%2Bthin.png",
        },
        video: {
            title: "Thick and Thin Video",
            url: "https://content.songfinch.com/res/songfinch/video/static/thick-thin.mp4",
        }
    },
    {
        contentTypeId: "review",
        reviewText: "This song has literally changed my life. Spoken to my lover's heart spoken through my heart. Can it make everything so amazing. Thank you so much. I'm so grateful and I can't wait to create more music with you.",
        avatar: {
            name: "Monique B."
        }
    },
    {
        contentTypeId: "pressReview",
        reviewText: "Through Songfinch, I found a way to send my prayers, offer my condolences, and sing my thanks in somebody else’s voice to somebody else’s beat…that, my friends, is The Gift.",
        logo: {
            title: "People",
            url: "https://content.songfinch.com/res/songfinch/image/statics/people-white.svg",
        },
    },
    // 2
    {
        contentTypeId: "reveal",
        title: "Unconditional Love",
        subtext: "by Annie Wildgen",
        placeholder: {
            title: "Unconditional Love Image",
            url: "https://content.songfinch.com/res/songfinch/image/asset/static/unconditional.png",
        },
        video: {
            title: "Unconditional Love Video",
            url: "https://content.songfinch.com/res/songfinch/video/static/unconditional.mp4",
        }
    },
    {
        contentTypeId: "review",
        reviewText: "Speechless!!! I absolutely love it and couldn't be more timely. I can't wait to set up that perfect moment for my wife to listen to it & record it...Thank you, thank you, THANK YOU!!",
        avatar: {
            name: "James T."
        }
    },
    {
        contentTypeId: "pressReview",
        reviewText: "How can we think outside the box of chocolates for the holiday? Songfinch writes and records custom songs sure to make their heart sing!",
        logo: {
            title: "Good Morning America",
            url: "https://content.songfinch.com/res/songfinch/image/statics/gma-white.svg",
        },
    },
    // 3
    {
        contentTypeId: "reveal",
        title: "Everything You Do",
        subtext: "by Trevor Martin",
        placeholder: {
            title: "Everything You Do Image",
            url: "https://content.songfinch.com/res/songfinch/image/asset/static/Snow-White.png",
        },
        video: {
            title: "Everything You Do Video",
            url: "https://content.songfinch.com/res/songfinch/video/static/everything-you-do.mp4",
        }
    },
    {
        contentTypeId: "review",
        reviewText: "She absolutely nailed it. It took me back through all the emotions of our relationship like she’s known us and our story for years. Beautiful voice. I literally could not be happier with the result, I cried. Can’t wait for the reveal!",
        avatar: {
            name: "Alexandra A."
        }
    },
    {
        contentTypeId: "pressReview",
        reviewText: "Songfinch is a creative love language gift for your other half. Get ready to spark romance and create new memories together!",
        logo: {
            title: "The Knot",
            url: "https://content.songfinch.com/res/songfinch/image/statics/theknot-white.svg",
        },
    },
    // 4
    {
        contentTypeId: "reveal",
        title: "IFLY",
        subtext: "by Nick Isham",
        placeholder: {
            title: "IFLY Image",
            url: "https://content.songfinch.com/res/songfinch/image/asset/static/i-f-l-y.png",
        },
        video: {
            title: "IFLY Video",
            url: "https://content.songfinch.com/res/songfinch/video/static/ifly.mp4",
        }
    },
    {
        contentTypeId: "review",
        reviewText: "Not going to lie, I was nervous about doing this. But, I thought, why not?!  I am SO happy I did.  Bekah freakin' nailed it!  The words, the vibe, EVERYTHING! It is better than I could ever imagined!!!  Can't wait to play it for my hubby!!",
        avatar: {
            name: "Jennifer R."
        }
    },
    {
        contentTypeId: "pressReview",
        reviewText: "Songfinch earned the 11th, 166th, and 238th spots on Inc. 5000’s list of the fastest-growing companies in the U.S from 2022 - 2024.",
        logo: {
            title: "Inc",
            url: "https://content.songfinch.com/res/songfinch/image/statics/inc-white.svg",
        },
    },
];